import { PAYMENT_METHOD_REQUEST } from '../actions/utilities';

const INITIAL_STATE = {
    getPaymentMethodLoading: false,
    getPaymentMethodSuccess: false,
    getPaymentMethodFailure: false,
    getPaymentMethodError: null,
    paymentMethodList: [],
    addPaymentMethodLoading: false,
    addPaymentMethodSuccess: false,
    addPaymentMethodFailure: false,
    addPaymentMethodError: null,
}

export const paymentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_REQUEST:
            return {
                ...state,
                getPaymentMethodLoading: true,
                getPaymentMethodSuccess: false,
                getPaymentMethodFailure: false,
                getPaymentMethodError: null
            }
        case PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_SUCCESS:
            return {
                ...state,
                getPaymentMethodLoading: false,
                getPaymentMethodSuccess: true,
                getPaymentMethodFailure: false,
                getPaymentMethodError: null,
                paymentMethodList: action.payload
            }
        case PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_FAILURE:
            return {
                ...state,
                getPaymentMethodLoading: false,
                getPaymentMethodSuccess: false,
                getPaymentMethodFailure: true,
                getPaymentMethodError: action.payload
            }
        case PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_REQUEST:
            return {
                ...state,
                addIncomeTypeLoading: true,
                addIncomeTypeSuccess: false,
                addIncomeTypeFailure: false,
                addIncomeTypeError: null
            }
        case PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_SUCCESS:
            let paymentMethods = state.paymentMethodList;
            paymentMethods.push(action.payload)
            return {
                ...state,
                addIncomeTypeLoading: false,
                addIncomeTypeSuccess: true,
                addIncomeTypeFailure: false,
                addIncomeTypeError: null,
                paymentMethodList: paymentMethods
            }
        case PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_FAILURE:
            return {
                ...state,
                addIncomeTypeLoading: false,
                addIncomeTypeSuccess: false,
                addIncomeTypeFailure: true,
                addIncomeTypeError: action.payload
            }
        case PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_REQUEST:
            return {
                ...state,
                addIncomeTypeLoading: true,
                addIncomeTypeSuccess: false,
                addIncomeTypeFailure: false,
                addIncomeTypeError: null
            }
        case PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_SUCCESS:
            let payment_method = state.paymentMethodList;
            for (let i = 0; i < state.paymentMethodList.length; i++) {
                if (payment_method[i].paymentMethodId === action.payload) {
                    payment_method.splice(i, 1);
                }
            }
            return {
                ...state,
                addIncomeTypeLoading: false,
                addIncomeTypeSuccess: true,
                addIncomeTypeFailure: false,
                addIncomeTypeError: null,
                paymentMethodList: payment_method
            }
        case PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_FAILURE:
            return {
                ...state,
                addIncomeTypeLoading: false,
                addIncomeTypeSuccess: false,
                addIncomeTypeFailure: true,
                addIncomeTypeError: action.payload
            }
        case PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_REQUEST:
            return {
                ...state,
                addIncomeTypeLoading: true,
                addIncomeTypeSuccess: false,
                addIncomeTypeFailure: false,
                addIncomeTypeError: null
            }
        case PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_SUCCESS:
            let paymentMethod_ = state.paymentMethodList;
            for (let i = 0; i < state.paymentMethodList.length; i++) {
                if (paymentMethod_[i].paymentMethodId === action.payload.paymentMethodId) {
                    paymentMethod_[i] = action.payload
                }
            }
            return {
                ...state,
                addIncomeTypeLoading: false,
                addIncomeTypeSuccess: true,
                addIncomeTypeFailure: false,
                addIncomeTypeError: null,
                paymentMethodList: paymentMethod_
            }
        case PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_FAILURE:
            return {
                ...state,
                addIncomeTypeLoading: false,
                addIncomeTypeSuccess: false,
                addIncomeTypeFailure: true,
                addIncomeTypeError: action.payload
            }
        default:
            return state;
    }
}